<template>
<div>
    <AppNav></AppNav>
    <div class="row">
      <div class="col-lg-6"></div>
    </div>
    <div  class="row">
      <div class="col-sm-1"></div>
      <div class="col-xs-12  col-sm-8">
        <h3> Modifier les dates du contrat !</h3>
        <form>
          <div class="row">
            <div class="col-md-6">    
                <input id="titulaire" name ="titulaire" type="text"  class="form-control" disabled   :value="contratById.titulaireByTitulaireId.fullName" />
                   
                <input name ="remplacant" type="text"  class="form-control" disabled :value="contratById.remplacantByRemplacantId.fullName" />
                    
                <input :value="contratById.date1" name ="date1" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" required v-on:change="updateField('date1', $event.target.value)" />
                <input  :value="contratById.date2" name ="date2" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" v-on:change="updateField('date2', $event.target.value)"  />
                <input  :value="contratById.date3" name ="date3" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" v-on:change="updateField('date3', $event.target.value)"  />
                <input :value="contratById.date4" name ="date4" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" v-on:change="updateField('date4', $event.target.value)" />
                <input :value="contratById.date5" name ="date5" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" v-on:change="updateField('date5', $event.target.value)" />
                <input :value="contratById.date6" name ="date6" type="date"  class="form-control"  data-format="EE, dd MMMM yyyy" v-on:change="updateField('date6', $event.target.value)"  />
                <input  type="submit" value="Valider" class="btn btn-primary btn-block" @click.prevent="editContrat" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-xs-12.col-sm-4"> 
      <p class="lead">{{sidebar}}</p>
    </div>
</div>
</template>
<script>
import AppNav from '../AppNav'
import moment from 'moment'
import  _  from "underscore"
import {
  CONTRAT_BY_ID_QUERY,
  UPDATE_CONTRAT,
  ALL_CONTRATS_QUERY,
} from '../../constants/graphql'

export default {
  name: 'contrat-edit',
  components: {
    AppNav
  },
  data() {
    return {
      moment: moment,
      contratById: {},
      allContrats: [],
      sidebar: "",
      date1: null,
      date2: null,
      date3: null,
      date4: null,
      date5: null,
      date6: null
    }
  },
  apollo: {
    allContrats:{
        query: ALL_CONTRATS_QUERY,
          variables: {
        offset: 20,
        first:1000
      }
    },
    contratById: {
      query: CONTRAT_BY_ID_QUERY,
      variables() {
          var id = parseInt(this.$route.params.id,10)
          return{
              id
          }
      }
    }
  },
  methods: {
      // oldDate: contratById.date
      // newDate: this.date
    updateDate: function(oldDate, newDate){
        if(_.isNull(newDate)){
            return oldDate;
        }else if(_.isEmpty(newDate)){
            return null;
        }else {
            return newDate
        }
    },
        editContrat: function () {  
            const date1 = this.updateDate(this.contratById.date1, this.date1)
            const date2 = this.updateDate(this.contratById.date2, this.date2)
            const date3 = this.updateDate(this.contratById.date3, this.date3)
            const date4 = this.updateDate(this.contratById.date4, this.date4)
            const date5 = this.updateDate(this.contratById.date5, this.date5)
            const date6 = this.updateDate(this.contratById.date6, this.date6)
            var self = this;
            this.$apollo.mutate({
          mutation: UPDATE_CONTRAT,
          variables: {
           id: this.contratById.id,
            date1: date1,
            date2: date2,
            date3: date3,
            date4: date4,
            date5: date5,
            date6: date6
          },
           refetchQueries: [{
                query: ALL_CONTRATS_QUERY,
                variables: {
                  first: 20,
                  offset: 0
                }
            }]   
        }).then((data) => {
            self.$router.push({name: "Contrats"} )
        }).catch((error) => {
          // Error
          console.error("error",error)
          // We restore the initial user input
        })
        },    
      
      updateField( field,target){
          this[field] = target
      }
    }
  }
</script>
<style scoped>
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}


/*
 * Dashboard
 */


/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>



// WEBPACK FOOTER //
// contratsEdit.vue?180cba1e